import { ServiceStage } from "@/lib/types";

export const serviceStages: ServiceStage[] = [
  {
    number: "01",
    word: "Strategy",
    weeks: "Week 1–3",
    description:
      "Every powerful identity begins with clarity. We start by understanding your brand's purpose, audience, positioning and long-term vision.",
    points: [
      "Brand Discovery",
      "Market Research",
      "Audience Insights",
      "Positioning",
    ],
  },
  {
    number: "02",
    word: "Discovery",
    weeks: "Week 2–5",
    description:
      "Before the first sketch we immerse ourselves in your world, analysing the landscape so the work leads the conversation in your niche.",
    points: [
      "Stakeholder Interviews",
      "Industry Trends",
      "Visual Audit",
      "Touchpoint Mapping",
    ],
  },
  {
    number: "03",
    word: "Concept",
    weeks: "Week 4–8",
    description:
      "Insight becomes multiple creative directions — form, typography, symbolism — tested against a scalable foundation, not one hero mockup.",
    points: [
      "Sketch Exploration",
      "Symbol Design",
      "Concept Rationale",
      "Visual Testing",
    ],
  },
  {
    number: "04",
    word: "Refinement",
    weeks: "Week 7–10",
    description:
      "Proportion, spacing, alignment and balance refined until every curve is optimised for clarity from favicon through to billboard.",
    points: [
      "Grid System",
      "Vector Precision",
      "Colour System",
      "Scalability Testing",
    ],
  },
  {
    number: "05",
    word: "System",
    weeks: "Week 9–12",
    description:
      "A complete asset set with clear usage rules, so your team keeps the work consistent long after we sign off.",
    points: [
      "Brand Guidelines",
      "Typography Palette",
      "Digital Assets",
      "Brand Storybook",
    ],
  },
];
